// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","primary":"#56CCF2","secondary":"#33C370","container":"_2fTfTZjRR7kZb5yEE0b4GK","wrapper":"u8PTC4MES9Tr3raSvJ-37","resource":"_3sJgSpop8iY3lr7fEc080r","title":"_2U26MXgElCosgqgPoX4VL9","description":"_3b5aiKl0iVtu2hbM0NoKs3","icon-wrapper":"_3DS_qFV2htpA6Wr0SJFJpG","icon":"_3e4Te9QGorUXm7mYXcEjb-","lecture":"_3v93Lh4-4rg3FLiIxrOrn-","link":"_1fbvMBOWA5FmWEFENkVSN1","lecture-img":"_1g3pnDKtXV7lKtrxXpVGX","video":"_2ZwwiWwy_EMoVCbhbQ4X-V","video-img":"nyWbdp7FH8mkZDuLiSGoH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResourcePreview/ResourcePreview.mod.css
// module id = 1638
// module chunks = 0